import React, { useState } from 'react';
import './style.scss';

const LegendMobile = ({ items, activeMap, onMapChange }) => {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [_, setLastClickedButton] = useState('next');

  const mapList = ['tang-tret', 'khoi-podium', 'rooftop'];
  const currentMapIndex = mapList.indexOf(activeMap);

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      // Swipe left
      setLastClickedButton('next');
      const nextMapIndex =
        currentMapIndex === mapList.length - 1 ? 0 : currentMapIndex + 1;
      onMapChange(mapList[nextMapIndex]);
    }
    if (isRightSwipe) {
      // Swipe right
      setLastClickedButton('prev');
      const prevMapIndex =
        currentMapIndex === 0 ? mapList.length - 1 : currentMapIndex - 1;
      onMapChange(mapList[prevMapIndex]);
    }
  };

  // Xử lý nút điều hướng
  const handlePrevMap = () => {
    setLastClickedButton('prev');
    const prevMapIndex =
      currentMapIndex === 0 ? mapList.length - 1 : currentMapIndex - 1;
    onMapChange(mapList[prevMapIndex]);
  };

  const handleNextMap = () => {
    setLastClickedButton('next');
    const nextMapIndex =
      currentMapIndex === mapList.length - 1 ? 0 : currentMapIndex + 1;
    onMapChange(mapList[nextMapIndex]);
  };

  if (!items || !Array.isArray(items)) {
    return (
      <div className="legend-mobile">
        <div className="legend-mobile-content">
          <div className="legend-mobile-title">
            THỂ THAO & RÈN LUYỆN THỂ CHẤT
          </div>
          <div className="legend-mobile-items">
            <div className="legend-mobile-item">
              <div className="legend-mobile-text">Không có dữ liệu</div>
            </div>
          </div>
        </div>
        <div className="legend-mobile-navigation">
          <button
            className="nav-btn prev-btn"
            onClick={handlePrevMap}
            disabled={currentMapIndex === 0}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M7.5 9L4.5 6L7.5 3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button
            className="nav-btn next-btn"
            onClick={handleNextMap}
            disabled={currentMapIndex === mapList.length - 1}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M4.5 3L7.5 6L4.5 9"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="legend-mobile"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="legend-mobile-content">
        {items.map((group, groupIndex) => (
          <div key={groupIndex} className="legend-mobile-group">
            <div className="legend-mobile-title">{group.title}</div>
            <div className="legend-mobile-items">
              {group.child.map((item) => (
                <div className="legend-mobile-item" key={item.id}>
                  <div className="legend-mobile-id">{item.id}</div>
                  <div className="legend-mobile-text">{item.title}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* <div className="legend-mobile-navigation">
        <button
          className={`nav-btn prev-btn ${
            lastClickedButton === "prev" ? "active" : ""
          }`}
          onClick={handlePrevMap}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="14"
            viewBox="0 0 21 14"
            fill="none"
          >
            <path
              d="M19.75 6.75H0.75M0.75 6.75L6.75 0.75M0.75 6.75L6.75 12.75"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <button
          className={`nav-btn next-btn ${
            lastClickedButton === "next" ? "active" : ""
          }`}
          onClick={handleNextMap}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="14"
            viewBox="0 0 21 14"
            fill="none"
          >
            <path
              d="M0.75 6.75H19.75M19.75 6.75L13.75 0.75M19.75 6.75L13.75 12.75"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div> */}
    </div>
  );
};

export default LegendMobile;
